"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeldType = void 0;
/**
 * This enum enumerates the possible types of Meld.
 */
var MeldType;
(function (MeldType) {
    MeldType[MeldType["EYES"] = 0] = "EYES";
    MeldType[MeldType["CHOW"] = 1] = "CHOW";
    MeldType[MeldType["PONG"] = 2] = "PONG";
    MeldType[MeldType["KONG"] = 3] = "KONG";
    MeldType[MeldType["THIRTEEN_ORPHANS"] = 4] = "THIRTEEN_ORPHANS";
})(MeldType = exports.MeldType || (exports.MeldType = {}));
